import React, { useContext, useEffect, useState } from "react";
import { ProductSummary } from "../../../../../styles/orderform.tsx";
import { OrderContext } from "../../OrderContext.tsx";
import { DiscountRow, Variant } from "../../types.ts";
import { getAdditionalServices, getLeads, getPeriodNumberFromLabel, getVariation } from "../../../../../misc/helpers.ts";
import HorizontalLine from "./HorizontalLine.tsx";
import { useAppTranslation } from "../../../../../translations/useAppTranslation.ts";

function Summary() {
  const { formValues, products, addOns, leads, discountRows } = useContext(OrderContext);
  const { t, db_t } = useAppTranslation();

  const [selectedProduct] = useState<Variant | undefined>(getVariation({ products, contractTemplateId: formValues['product'] }));
  const [selectedAddons] = useState(getAdditionalServices({ additionalServices: addOns, selectedServices: formValues['additional-services'] }));
  const [selectedLeads] = useState(getLeads({ leads: leads, selectedServices: formValues['additional-services'] }));

  const [monthlyTotal, setMonthlyTotal] = useState(0);
  const [energyTotal, setEnergyTotal] = useState(0);
  const [energyName, setEnergyName] = useState('common.energyPrice');

  const [discountRow, setDiscountRow] = useState<DiscountRow | undefined>(undefined);
  const [contractPeriod, setContractPeriod] = useState<number | undefined>(undefined);

  useEffect(() => {
    let monthlyTotal = selectedProduct?.monthly_price ?? 0;
    let energyTotal = selectedProduct?.energy_price ?? 0;
    selectedAddons.forEach(addon => {
      if (addon.monthly_price) {
        monthlyTotal += addon.monthly_price;
      }
      if (addon.energy_price) {
        energyTotal += addon.energy_price;
      }
    });
    setMonthlyTotal(monthlyTotal);
    setEnergyTotal(energyTotal);
  }, [selectedAddons, selectedProduct]);

  useEffect(() => {
    let name = 'common.energyPrice';
    if (selectedProduct?.name.includes('rssis')) {
      name = 'common.margin';
    } else if (selectedProduct?.name.includes('ynergia')) {
      name = 'common.priceForecast';
    }
    setEnergyName(name);

    setDiscountRow(discountRows.find(row => row.productId === selectedProduct?.hs_id));
    setContractPeriod(getPeriodNumberFromLabel(selectedProduct?.contract_period.label ?? ''));
  }, [selectedProduct]);

  return (
    <ProductSummary className="b2b">
      <div className="card-title">{t('phaseThree.contractAndAddons')}</div>
      <div>
        {selectedProduct && <div className="title">{db_t(selectedProduct, 'name')} </div>}
        {(selectedProduct && selectedProduct.description_in_summary)
          ? <div dangerouslySetInnerHTML={{ __html: db_t(selectedProduct, 'description')}}></div>
          : null}
        {selectedProduct && !!selectedProduct.campaign_text && <div className="description" dangerouslySetInnerHTML={{ __html: selectedProduct.campaign_text }}></div>}
        <ul>
          {selectedProduct && <li>{t('common.monthlyPrice')} <b>{(discountRow && (contractPeriod == null || discountRow.duration <= contractPeriod)) ? '0' : selectedProduct.monthly_price } {t('common.€/month')} {(discountRow) && <span>{contractPeriod == undefined || discountRow.duration < contractPeriod ? `${discountRow.duration} ${t('common.months')} ` : ''}</span>} </b> /{t('phaseThree.placeOfUse')}</li>}
          {(discountRow) && <div>(norm. {selectedProduct?.monthly_price}{t('common.€/month')})</div>}
          {selectedProduct && <li>{t(energyName)} <b>{selectedProduct.energy_price} {t('common.c/kWh')} {selectedProduct?.name.includes('Joustos') ? `+ ${t('common.consumptionImpact').toLowerCase()}` : ''}</b></li>}
        </ul>
      </div>
      {selectedAddons.map(addon => (
        <div key={addon.addon_product_template_no}>
          <div className="title">{addon.type.label}</div>
          <ul>
            {addon.energy_price && <li>{t('common.energyPrice')} <b>{addon.energy_price} {t('common.c/kWh')}</b></li>}
            {addon.monthly_price && <li>{t('common.monthlyPrice')} <b>{addon.monthly_price} {t('common.€/month')}</b></li>}
          </ul>
        </div>
      ))}
      {selectedLeads.length > 0 && <div className="card-title">{t('phaseThree.queries')}</div>}
      {selectedLeads.map(lead => (
        <div key={lead.hs_id}>
          <div className="title">{db_t(lead, 'name')}</div>
          <ul>
            <li>{db_t(lead, 'label')}</li>
          </ul>
        </div>
      ))}

      <HorizontalLine />
      <div className="title">{t('phaseFour.total')}</div>
      <div><b>{monthlyTotal} {t('common.€/month')}</b> /{t('phaseThree.placeOfUse')} <b>{selectedProduct?.name.includes('rssis') ? ' + SPOT ' : ''}+ {energyTotal} {t('common.c/kWh')} {selectedProduct?.name.includes('Joustos') ? `+ ${t('common.consumptionImpact').toLowerCase()}` : ''}</b> {t('phaseThree.basedOnUsage')}</div>

    </ProductSummary>
  )
}

export default Summary;
